import React, { useEffect, useRef } from "react";
import { useState } from "react";
import {
  Divider,
  Typography,
  Button,
  Box,
  Modal,
  Radio,
  FormControlLabel,
  OutlinedInput,
  Checkbox,
  Switch,
  Link,
  Select,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Popover,
  Popper,
  Fade,
  Paper,
  ClickAwayListener,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import {
  getInviteeAnswers,
  getInviteeQuestions,
} from "../../../graphql/querys";
import {
  Add,
  ArrowDropDown,
  CheckBox as Checkboxes,
  Delete,
  Dialpad,
  FormatAlignLeft,
  RadioButtonChecked,
  ShortText,
} from "@mui/icons-material";
import {
  ADD_INVITEE_QUESTION,
  DELETE_INVITEE_QUESTION,
} from "../../../graphql/mutations";
const Cancel = styled((props) => (
  <Button disableRipple variant="outlined" {...props} />
))({
  color: "black",
  border: "none",
  height: "30px",
  "&:hover": {
    backgroundColor: "transparent",
    border: "none",
  },
});
const Next = styled((props) => <Button variant="outlined" {...props} />)({
  color: "rgb(0,105,255)",
  borderRadius: "30px",
  height: "30px",
});

const InviteeQuestions = (props) => {
  const [showCancelModal, setShowCancelModal] = useState(false);

  const {
    loading: answerLoading,
    error: answerError,
    data: answerData,
    refetch: answerRefetch,
  } = useQuery(getInviteeAnswers, {
    variables: {
      eventId: props.eventId,
    },
  });
  const [deleteInviteeQuestion] = useMutation(DELETE_INVITEE_QUESTION);
  const [addInviteeQuestion] = useMutation(ADD_INVITEE_QUESTION);
  const handleCancel = (vars) => {
    const question = {
      eventId: props.eventId, // replace with actual event ID
      title: vars.title,
      required: vars.required,
      type: vars.answerType,
      options: vars.options,
    };
    if (vars.questionId) {
      question.questionId = parseInt(vars.questionId);
    }
    addInviteeQuestion({
      variables: question,
    })
      .then((val) => {
        setShowCancelModal(false);
        props.refetch();
        answerRefetch();
      })
      .catch((err) =>
        console.log({
          variables: {
            question,
          },
        })
      );
  };
  const deleteQuestion = () => {
    deleteInviteeQuestion({ variables: { id: parseInt(showCancelModal) } })
      .then((val) => {
        props.refetch();
        answerRefetch();
        setShowCancelModal(false);
      })
      .catch((err) => console.err(err));
  };
  const CancelModal = () => {
    const questionData =
      showCancelModal !== true
        ? props.data.getInviteeQuestions.find(
            (val) => val.id == showCancelModal
          )
        : [];
    const answersData = questionData
      ? answerData.getInviteeAnswers.filter(
          (val) => val.questionId == questionData.id
        )
      : [];
    const types = [
      { text: "One Line", icon: <ShortText /> },
      { text: "Multiple Lines", icon: <FormatAlignLeft /> },
      { text: "Radio Buttons", icon: <RadioButtonChecked />, type: "options" },
      { text: "Checkboxes", icon: <Checkboxes />, type: "options" },
      { text: "Drop down", icon: <ArrowDropDown />, type: "options" },
      { text: "Phone Number", icon: <Dialpad /> },
    ];
    const [required, setRequired] = useState(
      questionData?.id ? questionData.required : false
    );
    const [answerType, setAnswerType] = useState(
      questionData?.id ? questionData.type : "One Line"
    );
    const [question, setQuestion] = useState(
      questionData?.id ? questionData.title : ""
    );
    const [answers, setAnswers] = useState(
      answersData?.length ? answersData.map((val) => val.title) : ["", "", ""]
    );
    const [errors, setErrors] = useState(null);
    function deleteIndex(ind) {
      var e = answers.slice();
      e.splice(ind, 1);
      setAnswers(e);
    }
    function updateInd(ind, val) {
      var e = answers.slice();
      e[ind] = val;
      setAnswers(e);
    }
    function findDuplicateAnswers() {
      const duplicates = [];

      answers.forEach((answer, index) => {
        const duplicateIndex = answers.findIndex((otherAnswer, otherIndex) => {
          return index !== otherIndex && otherAnswer === answer;
        });

        if (duplicateIndex !== -1 && !duplicates.includes(answer)) {
          duplicates.push(answer);
        }
      });

      return duplicates;
    }
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setOpen(!open);
    };

    const handleClose = () => {
      setAnchorEl(null);
      setOpen(false);
    };

    return (
      <Modal
        open={showCancelModal}
        onClose={() => {
          setShowCancelModal(false);
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "10%",
            left: "50%",
            transform: "translateX(-50%)",
            overflowY: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
            outline: "none",
            width: "340px",
            maxHeight: "80vh",
          }}
        >
          <Typography variant="h5" sx={{ mb: 2 }}>
            New Question
          </Typography>
          <Typography>Question*</Typography>
          <OutlinedInput
            multiline
            rows={3}
            disabled={questionData?.title == "Email" ||
            questionData?.title == "Name" ||
            (questionData?.title == "Phone Number"&&props.phoneNumber)}
            fullWidth
            value={question}
            error={!!errors && !errors.includes("unique")}
            onChange={(event) => setQuestion(event.target.value)}
          />{" "}
          {errors && !errors.includes("unique") && (
            <Typography style={{ color: "red" }}>{errors}</Typography>
          )}
          <div
            style={{
              width: "100%",
              padding: "10px 0",
              justifyContent: "flex-end",
            }}
            className="flex align"
          >
            <Switch
              onChange={() => setRequired(!required)}
              checked={required}
              disabled={
                questionData?.title == "Email" ||
                questionData?.title == "Name" ||
                (questionData?.title == "Phone Number"&&props.phoneNumber)
              }
            />
            Required
          </div>
          <div
            style={{ padding: "0 0 20px 0", gap: "5px" }}
            className="flex column"
          >
            <Typography>Answer Type*</Typography>
            <Select
              value={answerType}
              fullWidth
              onChange={(event) => setAnswerType(event.target.value)}
            >
              {types.map((val) => (
                <MenuItem value={val.text} className="displayFlex">
                  <div style={{ display: "flex", gap: "10px" }}>
                    {val.icon}
                    <Typography>{val.text}</Typography>
                  </div>
                </MenuItem>
              ))}
            </Select>
          </div>
          {types.find((val) => answerType == val.text)?.type && (
            <>
              <Typography>Answers</Typography>
              <Typography className="font2">
                Invitee can select one or many of the following:
              </Typography>
              <div
                style={{ gap: "15px", padding: "15px 0" }}
                className="flex column"
              >
                {answers.map((val, ind) => (
                  <div className="flex align" style={{ gap: "10px" }}>
                    <OutlinedInput
                      fullWidth
                      placeholder={"Option " + (ind + 1)}
                      value={val}
                      onChange={(e) => {
                        updateInd(ind, e.target.value);
                      }}
                      error={
                        errors &&
                        errors.includes("unique") &&
                        findDuplicateAnswers().includes(val)
                      }
                    />
                    {answers.length > 1 && (
                      <IconButton
                        onClick={() => deleteIndex(ind)}
                        style={{ width: "45px", height: "45px" }}
                      >
                        <Delete />
                      </IconButton>
                    )}
                  </div>
                ))}
                {errors && errors.includes("unique") && (
                  <Typography style={{ color: "red" }}>{errors}</Typography>
                )}
              </div>
              <Link
                style={{ cursor: "pointer", padding: "15px 0" }}
                onClick={() => {
                  var e = [];
                  e = answers.slice();
                  e.push("");
                  setAnswers(e);
                }}
              >
                <Add onClick={() => setShowCancelModal(true)} fontSize="10px" />{" "}
                Add another question
              </Link>
            </>
          )}
          {questionData?.title == "Email" ||
          questionData?.title == "Name" ||
          props.data?.getInviteeQuestions?.length == 1 ? (
            ""
          ) : (
            <Typography
              onClick={(e) => {
                props.phoneNumber && questionData?.title == "Phone Number"
                  ? handleClick(e)
                  : showCancelModal !== true
                  ? deleteQuestion()
                  : setShowCancelModal(false);
              }}
              className="flex align"
              style={{
                color: "red",
                gap: "5px",
                padding: "10px 0",
                cursor: "pointer",
              }}
            >
              <Delete />
              Delete Question
            </Typography>
          )}
          <Popper
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            transition
            style={{ zIndex: 2000 }}
          >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper sx={{ p: 2 }}>
                  Change the location to delete this question
                </Paper>
              </Fade>
            )}
          </Popper>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={() => setShowCancelModal(false)}
              sx={{ mr: 2 }}
            >
              Nevermind
            </Button>
            <Button
              variant="contained"
              style={{ background: "#d9bca9" }}
              onClick={() =>
                findDuplicateAnswers().length &&
                (answerType.toLowerCase().includes("check") ||
                  answerType.toLowerCase().includes("radio"))
                  ? setErrors("Radios need to be unique")
                  : props.data?.getInviteeQuestions.find(
                      (val) =>
                        val.title.replaceAll("\\s", "") ==
                        question.replaceAll("\\s", "")
                    ) &&
                    showCancelModal == true &&
                    questionData?.title !== question
                  ? setErrors("Choose a different name")
                  : !question
                  ? setErrors("Enter a name")
                  : handleCancel({
                      // replace with actual event ID
                      title: question,
                      questionId:
                        showCancelModal !== true ? showCancelModal : null,
                      required,
                      answerType,
                      options: types.find((val) => answerType === val.text)
                        ?.type
                        ? answers.filter((answer) => answer.trim() !== "")
                        : undefined,
                    })
              }
            >
              Yes
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  };
  if (props.loading || answerLoading) {
    return (
      <div className="addEventContainer" style={{margin:0}} id="section1">
        <div className="addEventBox">
          <div className="Top">
            <h3 style={{ fontWeight: 400 }}>Invitee Questions</h3>
          </div>
        </div>
      </div>
    );
  }
  if (props.error || answerError) {
    return "Error";
  }
  return (
    <div className="addEventContainer" style={{margin:0}} id="section1">
      <div className="addEventBox">
        <div
          className="Top"
          style={{ cursor: "pointer" }}
          onClick={() => {
            props.setSelectedTab(props.selectedTab !== 2 ? 2 : null);
          }}
        >
          <h3 style={{ fontWeight: 400 }}>Invitee Questions</h3>
        </div>
        <Divider />
        <div
          style={{
            display: props.selectedTab !== 2 && "none",
            minHeight: "300px",
            padding: "16px 24px",
            gap: "15px",
            maxWidth: "100%",
            paddingBottom: "50px",
          }}
          className="flex column"
        >
          <CancelModal />
          {props.data.getInviteeQuestions.map((val) => {
            return (
              <div
                onClick={() => {
                  setShowCancelModal(val.id);
                }}
              >
                <Typography>{val.title + (val.required ? "*" : "")}</Typography>
                {val.type.toLowerCase().includes("radio") ? (
                  <div className="flex column ">
                    {answerData.getInviteeAnswers
                      .filter((vall) => vall.questionId == val.id)
                      .map((val) => (
                        <FormControlLabel
                          value={val.title}
                          control={<Radio disabled />}
                          label={val.title}
                        />
                      ))}
                  </div>
                ) : val.type.toLowerCase().includes("checkbox") ? (
                  <div className="flex column ">
                    {answerData.getInviteeAnswers
                      .filter((vall) => vall.questionId == val.id)
                      .map((val) => (
                        <FormControlLabel
                          value={val.title}
                          control={<Checkbox checked={false} disabled />}
                          label={val.title}
                        />
                      ))}
                  </div>
                ) : (
                  <OutlinedInput
                    fullWidth
                    multiline={val.type.toLowerCase().includes("multi") && true}
                    rows={val.type.toLowerCase().includes("multi") && 4}
                    endAdornment={
                      val.type.toLowerCase().includes("drop") && (
                        <ArrowDropDown />
                      )
                    }
                    placeholder={
                      val.type.toLowerCase().includes("drop") && "Select..."
                    }
                    style={{ maxWidth: "500px" }}
                    disabled
                  />
                )}
              </div>
            );
          })}
          <Link
            style={{ cursor: "pointer" }}
            onClick={() => setShowCancelModal(true)}
          >
            <Add fontSize="10px" /> New Question
          </Link>
        </div>{" "}
      </div>
    </div>
  );
};
export default InviteeQuestions;
